import type { Folder, Quiz } from '@floorpoll/shared';
import { apiRequest } from './api.js';

/**
 * Story #76 — the folder endpoints, in one place so pages do not hand-build
 * URLs.
 *
 * `list` defaults a missing `folders` to an empty array: a workspace with no
 * folders groups nothing and renders the flat dashboard it always had, so the
 * page never has to distinguish "none yet" from "not loaded".
 */
export const folderApi = {
  list: (workspaceId: string) =>
    apiRequest<{ folders: Folder[] }>(`/workspaces/${workspaceId}/folders`).then(
      (r) => r.folders ?? [],
    ),

  create: (workspaceId: string, name: string) =>
    apiRequest<{ folder: Folder }>(`/workspaces/${workspaceId}/folders`, {
      method: 'POST',
      body: { name },
    }).then((r) => r.folder),

  rename: (workspaceId: string, folderId: string, name: string) =>
    apiRequest<{ folder: Folder }>(`/workspaces/${workspaceId}/folders/${folderId}`, {
      method: 'PATCH',
      body: { name },
    }).then((r) => r.folder),

  /** Deletes the folder only — the polls filed in it become unfiled. */
  remove: (workspaceId: string, folderId: string) =>
    apiRequest<void>(`/workspaces/${workspaceId}/folders/${folderId}`, { method: 'DELETE' }),

  /** Files a poll, or unfiles it with `null`. Works on a live poll. */
  setQuizFolder: (quizId: string, folderId: string | null) =>
    apiRequest<{ quiz: Quiz }>(`/quizzes/${quizId}/folder`, {
      method: 'PUT',
      body: { folderId },
    }).then((r) => r.quiz),
};
